<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #primary>
  <mat-icon color="primary">new_releases</mat-icon>
  Change status
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createContract()" *awIsInAnyRole="['admin', 'customer']"
              color="primary"
              mat-button>New contract
      </button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>

    <table (matSortChange)="doSortContracts($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
           matSort multiTemplateDataRows>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{ element.id }}</td>
      </ng-container>

      <!-- Description Column -->
      <!--      <ng-container class="w-10" matColumnDef="description">-->
      <!--        <th *matHeaderCellDef mat-header-cell mat-sort-header>Description</th>-->
      <!--        <td *matCellDef="let element" mat-cell> {{element.description}} </td>-->
      <!--      </ng-container>-->

      <!-- Title Column -->
      <ng-container matColumnDef="title">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Title</th>
        <td *matCellDef="let element" mat-cell> {{ element.title }}</td>
      </ng-container>

      <!-- Company Column -->
      <ng-container matColumnDef="company">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Company</th>
        <td *matCellDef="let element" mat-cell>
          {{ element.company?.companyName }}&nbsp;<i (click)="companyDetails(element)"
                                                     class="far fa-question-circle color-disabled cursor-pointer"></i>
        </td>
      </ng-container>

      <ng-container *ngIf="iAmLogistic" matColumnDef="numberOfBoxes">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Number of Boxes</th>
        <td *matCellDef="let element" mat-cell> {{ element.numberOfBoxes }}</td>
      </ng-container>


      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let element" mat-cell> {{ element.email }}</td>
      </ng-container>

      <!-- End Date Column -->
      <ng-container matColumnDef="endDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
        <td *matCellDef="let element" mat-cell> {{ element.endDate | date:"dd/MM/yyyy" }}</td>
      </ng-container>

      <!-- Extended End Date Column -->
      <ng-container matColumnDef="extendedEndDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Extended Date</th>
        <td *matCellDef="let element" mat-cell> {{ element.extendedEndDate | date:"dd/MM/yyyy" }}</td>
      </ng-container>

      <!-- Contract Type Column -->
      <ng-container matColumnDef="contractType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Contract Type</th>
        <td *matCellDef="let element" mat-cell class="uppercase"> {{
            element.thirdPartyContract ?
              contractTypes.partnership : contractTypes.directContract | splitCamelCase
          }}
        </td>
      </ng-container>

      <!-- Start Date Column -->
      <ng-container matColumnDef="startDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let element" mat-cell> {{ element.startDate | date:"dd/MM/yyyy" }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
        <td *matCellDef="let element" mat-cell>
          <small>{{ element.status | splitCamelCase }}</small>

          <ng-container *ngIf="element.status === contractStatus.boxesWaiting && element.boxes?.length !== 0">
            <br>
            <small>
              <i class="fas fa-clock"></i>
              Waiting for Start Date
            </small>
          </ng-container>
          &nbsp;
          <i (click)="statusDetails()" class="far fa-question-circle color-disabled cursor-pointer"></i>

        </td>

      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" class="text-right" mat-cell>
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">


            <!-- ICON FOR ACTION REQUIRED-->
            <ng-container *awIsInRoleAndStatusForThisEntity="[
              {permission: 'admin', status: contractStatus.new, entity: element},
              {permission: 'admin', status: contractStatus.approvalWaiting, entity: element},
              {permission: 'admin', status: contractStatus.boxesWaiting, entity: element},
              {permission: 'admin', status: contractStatus.closed, entity: element},
              {permission: 'customer', status: contractStatus.new, entity: element},
              {permission: 'customer', status: contractStatus.testbedAssociation, entity: element},
              {permission: 'logistic', status: contractStatus.boxesWaiting, entity: element},
              {permission: 'logistic', status: contractStatus.closed, entity: element},
              {permission: 'logistic', status: contractStatus.damageReported, entity: element},
            ]">
              <button (click)="dialogsService.alert('INFO',  getTooltip(element))" mat-icon-button>
                <mat-icon color="warn" [matTooltip]="getTooltip(element)">warning</mat-icon>
              </button>
            </ng-container>

            <!--ICON FOR NON-MANDATORY POSSIBLE ACTION-->
            <ng-container *awIsInRoleAndStatusForThisEntity="[
              {permission: 'admin', status: contractStatus.testbedAssociation, entity: element},
              {permission: 'admin', status: contractStatus.ongoing, entity: element},
              {permission: 'admin', status: contractStatus.extended, entity: element},
              {permission: 'customer', status: contractStatus.ongoing, entity: element},
              {permission: 'customer', status: contractStatus.extended, entity: element},
            ]">
              <button (click)="dialogsService.alert('INFO',  getTooltip(element))" mat-icon-button>
                <mat-icon color="accent" [matTooltip]="getTooltip(element)">notifications</mat-icon>
              </button>
            </ng-container>

            <!--ICON FOR LESS BOXES THAN IT SHOULD-->
            <!--
            <ng-container *awIsInRoleAndStatusForThisEntity="[
              {role: roles.admin, status: contractStatus.boxesWaiting, entity: element},
              {role: roles.admin, status: contractStatus.ongoing, entity: element},
              {role: roles.admin, status: contractStatus.extended, entity: element},
              {role: roles.customer, status: contractStatus.boxesWaiting, entity: element},
              {role: roles.customer, status: contractStatus.ongoing, entity: element},
              {role: roles.customer, status: contractStatus.extended, entity: element},
              {role: roles.logistic, status: contractStatus.boxesWaiting, entity: element},
              {role: roles.logistic, status: contractStatus.ongoing, entity: element},
              {role: roles.logistic, status: contractStatus.extended, entity: element},
            ]">
              Disable for now. After lambda cleaning this is not possible without downloading an information about number of boxes of a contract.


              <button (click)="dialogsService.alert('INFO',  getBoxesTooltip(element))" *ngIf="element.boxes?.length < element.numberOfBoxes" mat-icon-button>
                <mat-icon color="warn" [matTooltip]="getBoxesTooltip(element)">nearby_error</mat-icon>
              </button>

            </ng-container>
            -->

            <!--ACTIONS BUTTON-->
            <button [matMenuTriggerFor]="actions" mat-icon-button>
              <mat-icon>more_vert</mat-icon>
            </button>


            <!--ACTIONS MENU-->
            <mat-menu #actions="matMenu">
              <!--              <button *awIsInRoleAndStatusForThisEntity="[-->
              <!--                  {role: roles.admin, status: contractStatus.new, entity: element},-->
              <!--                  {role: roles.admin, status: contractStatus.approvalWaiting, entity: element},-->
              <!--                  {role: roles.admin, status: contractStatus.testbedAssociation, entity: element},-->
              <!--                  {role: roles.admin, status: contractStatus.boxesWaiting, entity: element},-->
              <!--                  {role: roles.admin, status: contractStatus.ongoing, entity: element},-->
              <!--                  {role: roles.admin, status: contractStatus.extended, entity: element},-->
              <!--                  {role: roles.admin, status: contractStatus.closed, entity: element},-->
              <!--                  {role: roles.customer, status: contractStatus.new, entity: element},-->
              <!--                  {role: roles.customer, status: contractStatus.testbedAssociation, entity: element},-->
              <!--                  {role: roles.customer, status: contractStatus.ongoing, entity: element},-->
              <!--                  {role: roles.logistic, status: contractStatus.boxesWaiting, entity: element},-->
              <!--                  {role: roles.logistic, status: contractStatus.closed, entity: element},-->
              <!--                  {role: roles.logistic, status: contractStatus.damageReported, entity: element}-->
              <!--              ]"-->
              <!--                [matMenuTriggerFor]="management" mat-menu-item>-->
              <!--                MANAGEMENT-->
              <!--              </button>-->
              <!--              -->
              <!--              <button [matMenuTriggerFor]="info" mat-menu-item>-->
              <!--                INFO-->
              <!--              </button>-->

              <!--Show details-->
              <button (click)="details(element)" [disabled]="disabled" mat-menu-item>
                <mat-icon>visibility</mat-icon>
                Show details
              </button>

              <!--Expand testbed-->
              <ng-container *ngIf="element?.testbed">
                <button (click)="expandTestbed(element)"
                        *awIsInAnyRole="['admin', 'customer', 'tester']"
                        [disabled]="disabled" mat-menu-item>
                  <mat-icon>developer_mode</mat-icon>
                  Show testbed
                </button>
              </ng-container>

              <!--Expand boxes-->
              <ng-container *ngIf="element.boxes?.length !== 0">
                <button (click)="expandBoxes(element)"
                        *awIsInAnyRole="['admin', 'customer', 'logistic']"
                        [disabled]="disabled" mat-menu-item>
                  <mat-icon>grid_view</mat-icon>
                  Show all boxes
                </button>
              </ng-container>

              <!--Expand history-->
              <button (click)="expandContractHistory(element)"
                      *awIsInAnyRole="['admin', 'customer']"
                      [disabled]="disabled" mat-menu-item>
                <mat-icon>history</mat-icon>
                Show contract history
              </button>

              <!--EDIT-->
              <button (click)="editContract(element)" *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: contractStatus.new, entity: element},
                {permission: 'customer', status: contractStatus.new, entity: element},
                {permission: 'customer', status: contractStatus.testbedAssociation, entity: element},
                {permission: 'admin', status: contractStatus.ongoing, entity: element},
                {permission: 'customer', status: contractStatus.ongoing, entity: element},
                {permission: 'admin', status: contractStatus.extended, entity: element},
                {permission: 'customer', status: contractStatus.extended, entity: element}
              ]" [disabled]="disabled" mat-menu-item>
                <mat-icon>edit</mat-icon>
                Edit contract
              </button>

              <!--Change status-->
              <!--Change status-->
<button (click)="performAction(element)" mat-menu-item>
  <mat-icon color="grey">new_releases</mat-icon>
  Change status
</button>

              <!--Assign box-->
              <button (click)="addBoxesToThisContract(element)" *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: contractStatus.boxesWaiting, entity: element},
                {permission: 'logistic', status: contractStatus.boxesWaiting, entity: element},
                {permission: 'admin', status: contractStatus.ongoing, entity: element},
                {permission: 'logistic', status: contractStatus.ongoing, entity: element},
                {permission: 'admin', status: contractStatus.extended, entity: element},
                {permission: 'logistic', status: contractStatus.extended, entity: element},
              ]" [disabled]="disabled" mat-menu-item>
                <mat-icon>add_box</mat-icon>
                Add a box
              </button>

              <!--DELETE-->
              <button (click)="deleteContract(element)" *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: contractStatus.new, entity: element},
                {permission: 'customer', status: contractStatus.new, entity: element},
                {permission: 'admin', status: contractStatus.approvalWaiting, entity: element},
                {permission: 'customer', status: contractStatus.approvalWaiting, entity: element}
              ]" [disabled]="disabled" mat-menu-item>
                <mat-icon>delete</mat-icon>
                Delete contract
              </button>

            </mat-menu>

          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedCompany">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Associated Company</h3>
            <button (click)="expandedCompany = undefined" mat-button>Close</button>
          </div>
          <aw-list-companies *ngIf="expandedCompany == element" [company]="element.company"
                             [embeddedLayout]="true"></aw-list-companies>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedTestbed">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row">
            <h3 class="mb-0" fxFlex>Associated Testbed</h3>
            <button (click)="expandedTestbed = undefined" mat-button>Close</button>
          </div>
          <aw-list-testbeds *ngIf="expandedTestbed == element" [embeddedLayout]="true"
                            [testbed]="element?.testbed"
                            [contract]="element"></aw-list-testbeds>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractEvents">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <h3 class="mb-0" fxFlex>Events history</h3>
            <button (click)="expandedContractEventsHistory = undefined" mat-button>Close</button>
          </div>
          <aw-list-contract-events *ngIf="expandedContractEventsHistory == element"
                                   [contractId]="element.id"></aw-list-contract-events>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractBoxes">
        <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <h3 class="mb-0" fxFlex>Associated Boxes</h3>
            <button (click)="addBoxesToThisContract(element)"
                    *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: contractStatus.boxesWaiting, entity: element},
                {permission: 'logistic', status: contractStatus.boxesWaiting, entity: element},
                {permission: 'admin', status: contractStatus.ongoing, entity: element},
                {permission: 'logistic', status: contractStatus.ongoing, entity: element},
                {permission: 'admin', status: contractStatus.extended, entity: element},
                {permission: 'logistic', status: contractStatus.extended, entity: element}
              ]" color="primary" mat-button>
              Add boxes
            </button>

            <button (click)="expandedContractBoxes = undefined" mat-button>Close</button>
          </div>
          <aw-list-boxes *ngIf="expandedContractBoxes == element" [contract]="element"
                         [embeddedLayout]="true"></aw-list-boxes>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <tr *matRowDef="let row; columns: ['contractEvents']" [fxShow]="expandedContractEventsHistory?.id === row.id"
          mat-row></tr>
      <tr *matRowDef="let row; columns: ['contractBoxes']" [fxShow]="expandedContractBoxes?.id === row.id" mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedCompany']" [fxShow]="expandedCompany?.id === row.id" mat-row></tr>
      <tr *matRowDef="let row; columns: ['expandedTestbed']" [fxShow]="expandedTestbed?.id === row.id" mat-row></tr>


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">No contracts found</td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorContracts [fxShow]="dataSource && dataSource.data.length > 10"
                 [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" class="mat-elevation-z1"
                 showFirstLastButtons></mat-paginator>
</div>
